import uniqueId from 'lodash/uniqueId'

import { DOC_FLOW_UPLOADING_DEFAULT_TYPE } from '../../DocFlowUploading'

export function getAppearanceFileNameTimes(files) {
  return files.reduce((acc, cur) => {
    return {
      ...acc,
      [cur.name]: (acc[cur.name] || 0) + 1,
    }
  }, {})
}

export function getUploadingFilesAfterUploaded(files, uploadedFiles) {
  const fileTimes = getAppearanceFileNameTimes(uploadedFiles)

  return files.filter(file => {
    if (fileTimes[file.name]) {
      fileTimes[file.name] = fileTimes[file.name] - 1

      return false
    }

    return true
  })
}

export function getUploadedFilesAfterReload(files, uploadedIds) {
  return files.filter(file => !uploadedIds.includes(file.id))
}

export function getPreparedUploadingFiles(files) {
  return files.map(item => ({
    ...item,
    id: uniqueId(),
    type: DOC_FLOW_UPLOADING_DEFAULT_TYPE,
  }))
}
